import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  codigo: Yup.string().min(1).max(8).required(),
  descripcion: Yup.string().min(1).required()
})
